import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './AuthCode.scss';

class AuthCode extends Component {
  state = {
    countStatus: false, //获取验证码状态
    countDownTime: 60,
    hasSend: false, //是否发送过验证码
  }

  //props更新时生命周期
  componentWillReceiveProps(nextProps) {
    if (this.props.isSend !== nextProps.isSend && nextProps.isSend) {
      this.send();
      nextProps.onSuccessSend();
      this.setState({
        hasSend: true
      })
    }
    if (!nextProps.isHighColor) {
      this.setState({
        countStatus: false
      });
      clearInterval(this.timer);
    }
  }

  //组件销毁
  componentWillUnmount() {
    clearInterval(this.timer);
  }

  send = () => {
    this.setState({
      countStatus: true,
      countDownTime: 60
    });
    this.timer = setInterval(this.countDown, 1000);
  }

  //获取验证码
  countDown = () => {
    const { countDownTime } = this.state;
    if (countDownTime === 1) {
      clearInterval(this.timer);
      this.setState({
        countStatus: false
      })
    } else {
      this.setState({
        countDownTime: countDownTime - 1,
        countStatus: true
      })
    }
  }

  //验证手机号
  handlePhone = () => {
    this.props.onHandlePhone();
  }

  render () {
    let { countStatus, countDownTime, hasSend } = this.state;
    return (
        <span onClick={this.props.isHighColor && !countStatus ? this.handlePhone : () => {return}} className={`authCode ${this.props.isHighColor ? '' : ''}`}>{countStatus ? `${countDownTime}s后获取` : `${hasSend && this.props.isHighColor ? '重新' : ''}获取验证码`}</span>
    )
  }
}

AuthCode.propTypes = {
  isSend: PropTypes.bool.isRequired,
  isHighColor: PropTypes.bool,
  onHandlePhone: PropTypes.func.isRequired,
  onSuccessSend: PropTypes.func.isRequired
}

export default AuthCode;